import loadable from '@loadable/component';
import campaignPageQuery from './query.graphql';

const CampaignPage = loadable(() =>
  import(/* webpackChunkName: "campaigns" */ './campaign')
);

CampaignPage.graphQL = campaignPageQuery;

CampaignPage.loadOrder = [{}];

const FILTER_URL_PARAMS = [
  'category',
  'price',
  'productRating',
  'storeRating',
  'stores',
  'offset',
];

CampaignPage.variables = ({
  name,
  list: listSlug,
  min_price: minPrice,
  max_price: maxPrice,
  ...variables
}) => {
  return {
    id: /^\d+$/.test(name) ? parseInt(name, 10) : undefined,
    campaignSlug: name,
    listSlug,
    limit: 20,
    minPrice,
    maxPrice,
    filters: FILTER_URL_PARAMS.map(key =>
      variables[key] ? { key, value: variables[key] } : null
    ).filter(Boolean),
    peakIndexCategoryId: variables.category,
    campaignDeals: name === 'black-friday',
  };
};

CampaignPage.isActive = campaign => campaign?.state === 'ACTIVE';

export default CampaignPage;
